import React from "react";
import "./EbenchPlatform.css";
import { PiStudentBold } from "react-icons/pi";          
import { MdCastForEducation } from "react-icons/md";
import { IoMdBusiness } from "react-icons/io";
import { LiaLaptopCodeSolid } from "react-icons/lia";
const EbenchPlatform = () => {
  return (
    <section className="ebench-section">
      <div className="ebench-container">
        <div className="ebench-header">
          <h2 className="ebench-main-title">
            eBench <span className="highlight">Platforms</span>
          </h2>
          <div className="title-divider"></div>
          <p className="ebench-description">
            A unified ecosystem connecting students, universities, and companies — 
            enabling learning, growth, and career opportunities from campus to corporate.
          </p>
        </div>

        <div className="ebench-grid">
          {/* eBench Campus Card */}
          <div className="ebench-platform-card" style={{ '--card-color': '#286a94' }}>
            <div className="icon-wrapper">
              <PiStudentBold />
            </div>

            <h3 className="platform-title">eBench Campus</h3>

            <p className="platform-description">
              A platform for universities and vendors to efficiently manage, track, 
              and empower student communities across multiple programs.
            </p>

            <ul className="features-list">
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Centralized student registration and management</span>
              </li>
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Performance analytics via university dashboard</span>
              </li>
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Integrated access to eBench learning programs</span>
              </li>
            </ul>
          </div>

          {/* eBench Training Card */}
          <div className="ebench-platform-card" style={{ '--card-color': '#2d7ba8' }}>
            <div className="icon-wrapper">
              <MdCastForEducation />
            </div>

            <h3 className="platform-title">eBench Training</h3>

            <p className="platform-description">
              Industry-aligned training programs designed to upskill students and professionals 
              through practical, project-based learning.
            </p>

            <ul className="features-list">
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Hands-on courses on emerging technologies</span>
              </li>
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Mentorship from certified trainers and experts</span>
              </li>
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Skill development tailored for real-world use</span>
              </li>
            </ul>
          </div>

          {/* eBench Internship Card */}
          <div className="ebench-platform-card" style={{ '--card-color': '#3388bb' }}>
            <div className="icon-wrapper">
              <LiaLaptopCodeSolid />
            </div>

            <h3 className="platform-title">eBench Internship</h3>

            <p className="platform-description">
              A global internship network connecting talented learners 
              with real-world opportunities across remote, hybrid, and in-office models.
            </p>

            <ul className="features-list">
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Remote, hybrid, and on-site internship options</span>
              </li>
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Work with international startups and enterprises</span>
              </li>
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Internship access for eBench-certified learners</span>
              </li>
            </ul>
          </div>

          {/* eBench Hiring Card */}
          <div className="ebench-platform-card" style={{ '--card-color': '#3d95ce' }}>
            <div className="icon-wrapper">
              <IoMdBusiness />
            </div>

            <h3 className="platform-title">eBench Hiring</h3>

            <p className="platform-description">
              A dedicated hiring ecosystem that helps top-performing candidates 
              land full-time roles with global organizations.
            </p>

            <ul className="features-list">
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Guaranteed placement support for top performers</span>
              </li>
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>Direct hiring pipeline to partner companies</span>
              </li>
              <li>
                <span className="check-icon">
                  <svg viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span>AI-powered candidate–employer matching</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EbenchPlatform;